import React from 'react';

import * as S from './styles';

export function LoadingDots() {
  return (
    <S.Container>
      {[0, 1, 2].map(dot => (
        <S.Dot key={`loading-dot-${dot}`} />
      ))}
    </S.Container>
  );
}
